/* eslint-disable react-hooks/rules-of-hooks */
import { message } from 'antd';
import { useRouter } from 'next/router';
import { useTranslations } from 'next-intl';

export const errorHandler = () => {
  const t = useTranslations();
  const { locale } = useRouter();

  return (error: any) => {
    if (error.message === 'Network Error') {
      message.error(t('internet_yoq_tarmoqqa_ulanishingizni_tekshiring'));
    } else if (error.response?.status === 400) {
      message.error(
        typeof error.response.data?.message === 'string'
          ? error.response?.data?.message
          : error.response?.data?.message?.[locale || 'uz'] || t('xatolik_yuz_berdi')
      );
    } else {
      message.error(t('nomalum_xatolik_yuz_berdi'));
    }
  };
};
